<template>
<div class="animated fadeIn" style="padding-bottom:10px;" :id="id">
  <resize-observer @notify="handleResize" />
  <b-row >
    <b-col sm="4">
      <div class="input-bottom-line">
        <b-row>
          <b-col sm="1" style="padding-right:0px;padding-top:6px;">
            <b>{{rootIndex}}</b>
          </b-col>
          <b-col sm="3">
            <select :id="selectMedia" class="form-control no-border" :class="{error: errors.has(selectMedia)}" :name="selectMedia" v-validate="'required'" v-model="mediaInfo.media" required>
                <option value="" disabled selected hidden>미디어</option>
                <option v-for="(media_obj, media) in mediass" :value="media">{{media}}</option>
            </select>
          </b-col>
          <b-col sm="3">
            <select :id="selectChannel" class="form-control no-border" :class="{error: errors.has(selectChannel)}" :name="selectChannel" v-validate="'required'" v-model="mediaInfo.channel" required>
                <option value="" disabled selected hidden>채널</option>
                <option v-for="(channel_obj, channel) in channels" :value="channel">{{channel}}</option>
            </select>
          </b-col>
          <b-col sm="5">
            <select :id="selectVehicle" class="form-control no-border" :class="{error: errors.has(selectVehicle)}" :name="selectVehicle" v-validate="'required'" v-model="mediaInfo.vehicle" required>
                <option value="" disabled selected hidden>비히클</option>
                <option v-for="(vehicle_obj, vehicle) in vehicles" :value="vehicle_obj.screenName">{{vehicle_obj.screenName}}</option>
            </select>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col sm="1">
      <div  class="input-bottom-line" v-on:click="targetModal = !targetDisabled">
        <b-form-input :id="selectedTargetId" class="no-border" v-model="mediaInfo.genderLabel" type="text" placeholder="타겟" v-on:focus="targetModal = !targetDisabled" :disabled="targetDisabled"></b-form-input>
      </div>
    </b-col>
    <b-col sm="4">
      <b-row>
        <b-col sm="4">
          <!--
            화면에 보이는 데이터는 1000단위 컴마 처리를 해야하므로 budgetStr 이라는 text형 변수를 만들어서 활용
            text형이기 때문에 값제어를(숫자만입력되게) 할 수 없으므로 formatter 함수를 만들어서 값체크와 ',' 붙이기 처리를 함
            [ Budget, CPM, EImp 모두 동일 ]
          -->
          <div class="input-bottom-line">
            <b-form-input class="no-border" :class="{error: errors.has(mediaBudget)}" :name="mediaBudget"
            v-validate="'required|min:2'" v-model="mediaInfo.budgetStr" :formatter="format_budgetStr" type="text"></b-form-input>
          </div>
        </b-col>
        <b-col sm="4">
          <div class="input-bottom-line">
            <b-form-input class="no-border" :class="{error: errors.has(mediaCpm)}" :name="mediaCpm"
            v-validate="'required|min:3'" min=0 v-model="mediaInfo.cpmStr" :formatter="format_cpmStr" type="text" ></b-form-input>
          </div>
        </b-col>
        <b-col sm="4">
          <div class="input-bottom-line">
            <b-form-input class="no-border" :class="{error: errors.has(mediaEImp)}" :name="mediaEImp"
            v-validate="'required'" v-model="mediaInfo.eImpStr" :formatter="format_eImpStr" type="text"></b-form-input>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col sm="3">
      <b-row>
        <b-col sm="4">
          <div class="input-bottom-line" v-on:click="weightModalFlag = !weightModalFlag && mediaInfo.vehicle_type != 'system'" >
            <b-form-input :id="selectedWeightId" class="no-border inputPlaceholder" type="text" placeholder="system"  v-on:focus="weightModalFlag = !weightModalFlag"  :disabled="mediaInfo.vehicle_type == 'system'"></b-form-input>
          </div>
        </b-col>
        <b-col sm="5">
          <div class="input-bottom-line">
            <b-form-input class="no-border" type="text" :name="daterangeName" />
          </div>
        </b-col>
        <b-col sm="1">
          <b-button type="submit" size="sm" variant="light" style="background-color:transparent" class="btn-pill" @click="deleteThis">
            <span style="font-size:20px;font-weight:900;">X</span>
          </b-button>
        </b-col>
        <b-col sm="1">
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-modal title="목표 타겟 설정" size="lg" v-model="targetModal" @ok="targetModal = false">
    <reachTarget v-bind:formData="mediaInfo" ref="reachTargetRef"></reachTarget>
  </b-modal>
  <b-modal title="데이터 입력" size="lg" v-model="weightModalFlag"
  no-close-on-backdrop no-close-on-esc hide-footer>
    <weightModal v-bind:formData="mediaInfo" ref="weightModalRef"></weightModal>

    <hr />
    <span class="float-right" style="padding-right:20px;">
      <b-button variant="outline-primary" @click="weigthClose()">확인</b-button>
    </span>
  </b-modal>
</div>
</template>


<script>
const moment = require("moment");
import datetimepicker from "daterangepicker/daterangepicker.js";
import select2 from "select2/dist/js/select2.full.min.js";

import Vue from 'vue'
import VueResize from 'vue-resize'
Vue.use(VueResize)

import reachFormData from "../../common/ReachFormData.js";
import modelFormData from "../../common/ModelFormData.js";
import ReachUtils from "../../common/ReachUtils.js";
import reachTarget from "../../common/reachTarget.vue";
import WeightDB from "../../common/WeightDB.js";
import weightModal from "./WeightModal";

import cSwitch from '../../../components/Switch';

import numeral from 'numeral';

export default {
  filters:{
    thousands : function (value) {
      return numeral(value).format('0,0');
    }
  },
  // DateRangePicker
  components: {
    cSwitch,
    reachTarget,
    weightModal
  },
  props: {
    mediaList:null,
    // validateCheck:true,
    rootStartDate:null,
    rootEndDate:null,
    flagRootIndex:false,
  },
  data() {
    return {
      newRow:false,
      targetDisabled : false,
      validationFinish : false,
      mediaInfo : this.$_.clone(reachFormData.mediaInfo),
      mediaInfoHistory: null,
      demographics: null,
      id: null,
      targetModal: false,
      selectMedia: 'selectMedia',
      selectChannel: 'selectChannel',
      selectVehicle: 'selectVehicle',
      selectedTargetId: 'selectedTarget',
      selectedWeightId: 'selectedWeight',
      startDate: '',
      endDate: '',
      mediass: this.$_.clone(modelFormData.ScreenMediaStructure['DA']),
      channels: [],
      vehicles: [],
      mediaCpm:'',
      mediaEImp:'',
      daterangeName :'',
      rootIndex : null,
      cpmEimpFlag : 'cpm',
      weightModalFlag: false,
    }
  },
  beforeCreate: function() {},
  watch: {
    'flagRootIndex': function() {
      // 민스안 인덱스 번호가 갱신됬다는 신호를 받으면
      // 여기서 인덱스 번호를 주입해서 변경
      // this.mediaInfo.rootIndex <-- 이변수로 화면에 자동 변경이 안되서 아래와 같은 방법을 취함
      this.rootIndex =  this.mediaInfo.rootIndex;
    },
    'mediaInfo.media': function() {
      this.mediaInfo.channel = '전체';
      this.mediaInfo.vehicle = '전체';
      this.channels = [];
      this.vehicles = [];
      if (this.mediaInfo.media.length > 0) {
        this.channels = this.mediass[this.mediaInfo.media];
      }
      if (this.mediaInfo.channel.length > 0) {
        this.vehicles = this.mediass[this.mediaInfo.media][this.mediaInfo.channel];
      }
      if(this.mediaInfo.media == 'TV'){
        this.targetDisabled = true;
        this.$refs.reachTargetRef.disableTarget();
      }else{
        this.targetDisabled = false;
      }
    },
    'mediaInfo.channel': function() {
      this.mediaInfo.vehicle = '전체';

      if(this.mediaInfo.channel == '전체'){
        document.getElementById(this.selectChannel).style.color = "#67809F";
        document.getElementById(this.selectChannel).style.fontWeight = "normal";
        document.getElementById(this.selectVehicle).style.color = "#67809F";
        document.getElementById(this.selectVehicle).style.fontWeight = "normal";
      }else{
        document.getElementById(this.selectChannel).style.color = "#3e515b";
        document.getElementById(this.selectChannel).style.fontWeight = "600";
        document.getElementById(this.selectVehicle).style.color = "#3e515b";
        document.getElementById(this.selectVehicle).style.fontWeight = "600";
      }

      this.vehicles = [];

      if (this.mediaInfo.channel.length > 0) {
        this.vehicles = this.mediass[this.mediaInfo.media][this.mediaInfo.channel];
      }
      if(this.mediaInfo.channel == 'SMR'){
        this.$refs.reachTargetRef.disableTarget();
        this.targetDisabled = true;
      }else if(this.mediaInfo.media == 'TV'){
        this.$refs.reachTargetRef.disableTarget();
        this.targetDisabled = true;
      }else{
        this.targetDisabled = false;
      }
      //////////////////////////////////////////////////////////////////
    },
    'mediaInfo.vehicle': function(){

      if(this.newRow){
        if(this.mediaInfo.media == 'Mobile'){
          console.log(this.mediaInfo.bannerWidthStr + '/' + this.mediaInfo.bannerHeightStr);
          this.mediaInfo.bannerWidthStr = '300';
          this.mediaInfo.bannerHeightStr = '400';
        }else if(this.mediaInfo.media == 'PC'){
          this.mediaInfo.bannerWidthStr = '1024';
          this.mediaInfo.bannerHeightStr = '1080';
        }
      }

      var vehicles = this.mediass[this.mediaInfo.media][this.mediaInfo.channel];
      var len = this.mediass[this.mediaInfo.media][this.mediaInfo.channel].length;
      for(var i=0; i<len; i++){
        if(this.mediaInfo.vehicle == vehicles[i].screenName){
          this.mediaInfo.vehicle_type = vehicles[i].vehicle_type;
          if(this.mediaInfo.vehicle_type == 'custom'){
            document.getElementById(this.selectedWeightId).placeholder = "설정";
          }else{
            document.getElementById(this.selectedWeightId).placeholder = "system";
          }
        }
      }
    },
    // 입력받은 Budget과 CPM을 통해서 eImpression 계산
    'mediaInfo.budget':function(){
      this.$log.debug('watch mediaInfo.budget');
      this.mediaInfo.eImp = ((this.mediaInfo.budget * 10000) / this.mediaInfo.cpm ) * 1000;
      this.mediaInfo.eImp = this.mediaInfo.eImp.toFixed(0);
      if(!isFinite(this.mediaInfo.eImp)){
        this.mediaInfo.eImp = 0;
      }else{
        this.mediaInfo.eImpStr = numeral(this.mediaInfo.eImp).format('0,0');
      }
      // 부모 클래스 의 함수 호출
      this.$emit('changeBudget', true);
    },
    // 입력받은 Budget과 CPM을 통해서 eImpression 계산
    'mediaInfo.cpm':function(){
      this.$log.debug('watch mediaInfo.cpm');
      if(this.cpmEimpFlag === 'cpm'){
        this.mediaInfo.eImp = ((this.mediaInfo.budget * 10000) / this.mediaInfo.cpm ) * 1000;
        this.mediaInfo.eImp = this.mediaInfo.eImp.toFixed(0);
        this.mediaInfo.eImpStr = numeral(this.mediaInfo.eImp).format('0,0');
      }
    },
    // 입력받은 Impression과 Budget을 통하여 CPM 계산
    'mediaInfo.eImp':function(){
      this.$log.debug('watch mediaInfo.eImp');
      if(this.cpmEimpFlag === 'eImp' && this.mediaInfo.budget != 0){
        this.mediaInfo.cpm = ((this.mediaInfo.budget * 10000) / this.mediaInfo.eImp ) * 1000;
        this.mediaInfo.cpm = this.mediaInfo.cpm.toFixed(0);
        this.mediaInfo.cpmStr = numeral(this.mediaInfo.cpm).format('0,0');
        // this.format_cpmStr(this.mediaInfo.cpm.toFixed(0));
      }
    },
    'mediaInfo.targetOnOff':function(){
      if(this.mediaInfo.targetOnOff == false){
        document.getElementById(this.selectedTargetId).style.color = '#67809F';
        document.getElementById(this.selectedTargetId).style.fontWeight = 100;
        document.getElementById(this.selectedTargetId).style.fontStyle = 'italic';
      }else if(this.mediaInfo.targetOnOff == true){
        document.getElementById(this.selectedTargetId).style.color = '#3e515b';
        document.getElementById(this.selectedTargetId).style.fontWeight = 600;
        document.getElementById(this.selectedTargetId).style.fontStyle = 'normal';
      }
    },
    'rootStartDate':function(){
      this.createCalendar(false);
    },
    'rootEndDate':function(){
      this.createCalendar(false);
    },
  },
  mounted: function() {
    this.createCalendar(false);
    this.mediaList["#" + this.id] = this.mediaInfo; // 이거 지금 정상적으로 동작하고 있는 코드인가?
    var self = this;
    setTimeout(function(){
      self.newRow = true;
    }, 2500); // 2.5초후 실행 즐겨찾기에 등록된 데이터는 1초후 실행
    setTimeout(function(){
      self.$refs.reachTargetRef.demographicCount(); // 즐겨찾기 등록된 것이 아닌 신규매체 신규타겟
    }, 1000); // 1초후 실행
    this.mediaInfo.media_type = 'DA';
  },
  created: function() {
    this.id = this._uid + '_';
    this.mediaCpm = this.id + 'mediaCpm';
    this.mediaBudget = this.id + 'mediaBudget';
    this.mediaEImp = this.id + 'mediaEImp';

    this.selectMedia = this.id + 'selectMedia';
    this.selectChannel = this.id + 'selectChannel';
    this.selectVehicle = this.id + 'selectVehicle';
    this.selectedTargetId = this.id + 'selectedTarget';
    this.selectedWeightId = this.id + 'selectedWeightId';
    this.daterangeName = this.id + 'daterange';

    if(this.rootStartDate.length > 9){
      this.rootStartDate = this.rootStartDate.substring(2,10);
      this.rootEndDate = this.rootEndDate.substring(2,10);
    }
    this.mediaInfo.mediaStartDate = this.rootStartDate;
    this.mediaInfo.mediaEndDate = this.rootEndDate;
  },
  updated: function() {
  },
  methods: {
    weigthClose(){
      console.log('실행됨');
      console.log(this.mediaInfo.media);
      var size = parseInt(this.mediaInfo.bannerWidthStr) * parseInt(this.mediaInfo.bannerHeightStr);

      if(this.mediaInfo.media == 'PC'){
        if(size <= parseInt(WeightDB.data.device.pcStatic) && size > 0 ){
          // this.mediaInfo.bannerMsg = ''
          this.weightModalFlag = false;
        }else{
          // this.mediaInfo.bannerMsg = 'PC의 배너크기는 ' + WeightDB.data.device.pcStatic +'를 넘을 수 없습니다.'
          this.weightModalFlag = true;
        }
      }else if(this.mediaInfo.media == 'Mobile'){
        if(size <= parseInt(WeightDB.data.device.moStatic) && size > 0 ){
          // this.mediaInfo.bannerMsg = ''
          this.weightModalFlag = false
        }else{
          // this.mediaInfo.bannerMsg = 'Mobile의 배너크기는 ' + WeightDB.data.device.moStatic +'를 넘을 수 없습니다.'
          this.weightModalFlag = true;
        }
      }
    },
    format_budgetStr(value){
      this.$log.debug('format_budgetStr', value);
      var list = value.split('.');
      var val1, val2, final, result;
      if(list.length>1){
        var val1 = list[0].replace(/[($)\s\._\-]+/g, '');
        var val2 = list[1].replace(/[($)\s\._\-]+/g, '');
        final = val1 + '.'+ val2;
        result = numeral(final).format('0,0.0000');

      }else{
        var val1 = list[0].replace(/[($)\s\._\-]+/g, '');
        final = val1;
        result = numeral(final).format('0,0');
      }
      this.mediaInfo.budgetStr = final;
      this.mediaInfo.budget = numeral(final).format('00.0000');
      return result;
    },
    format_cpmStr(value){
      this.$log.debug('format_cpmStr', value);
      this.cpmEimpFlag = 'cpm';
      this.mediaInfo.cpmStr = value.replace(/[($)\s\._\-]+/g, '');
      this.mediaInfo.cpm = numeral(this.mediaInfo.cpmStr).format('0');
      return numeral(this.mediaInfo.cpmStr).format('0,0');
    },
    format_eImpStr(value){
      this.$log.debug('format_eImpStr', value);
      this.cpmEimpFlag = 'eImp';
      this.mediaInfo.eImpStr = value.replace(/[($)\s\._\-]+/g, '');
      this.mediaInfo.eImp = numeral(this.mediaInfo.eImpStr).format('0');
      return numeral(this.mediaInfo.eImpStr).format('0,0');
    },
    setSelectBoxbyHistory(){
      this.$refs.reachTargetRef.historyTargetForMediaTemplate(this.mediaInfoHistory); // 즐겨찾기에 저장된 개별 매체의 타겟 처리 (input타겟)
      if(this.mediaInfoHistory.channel !== '전체'){
        var self= this;
        setTimeout(function(){
          self.mediaInfo.channel = self.mediaInfoHistory.channel;
          self.createSelectFn(self);
        }, 500);
      }
      if(this.mediaInfoHistory.vehicle !== '전체'){
        var self= this;
        setTimeout(function(){
          self.mediaInfo.vehicle = self.mediaInfoHistory.vehicle;
          self.createSelectFn(self);
        }, 1000);
      }
      // 날짜 입력 도 여기서?
      this.createCalendar(true);

    },
    validateCheckFN(){
      this.$validator.validateAll().then(res=>{
        if(res) {
          this.mediaInfo.formValidation = true;
          this.validationFinish = true;
        } else {
          this.mediaInfo.formValidation = false;
          this.validationFinish = true;
        }
      })
    },
    handleResize() {
      this.createSelectFn(this);
    },
    createSelectFn(vm) {
      $('#' + this.selectMedia).on('change', function() {
        vm.$data.mediaInfo.media = this.value;
      }).on('hover', function() {
      });
      $('#' + this.selectChannel).on('change', function() {
        vm.$data.mediaInfo.channel = this.value;
      });
      $('#' + this.selectVehicle).on('change', function() {
        vm.$data.mediaInfo.vehicle = this.value;
      });
    }, // end createSelectFn
    deleteThis() {
      delete this.mediaList["#" + this.id];
      this.$emit('changeRootIndex', 500); // 부모 객체로 매체 index 재 개산 요청
      $("#" + this.id).fadeOut('slow', function() {
        document.getElementById(this.id).remove();
      });
      // document.getElementById(this.id).remove();
    },
    createCalendar(history){
      var mediaInfo = this.mediaInfo;
      if(!history){
        $('input[name='+this.daterangeName+']').daterangepicker({
          opens: 'left',
          "locale": reachFormData.calendarLocale,
          "startDate": this.rootStartDate,
          "endDate": this.rootEndDate,
          "minDate" : this.rootStartDate,
          "maxDate": this.rootEndDate
        }, function(start, end, label) {
          // mediaInfo.mediaStartDate = start.format('YYYY-MM-DD');
          // mediaInfo.mediaEndDate = end.format('YYYY-MM-DD');
          mediaInfo.mediaStartDate = start.format('YY/MM/DD');
          mediaInfo.mediaEndDate = end.format('YY/MM/DD');
        });
      }else if(history){
        $('input[name='+this.daterangeName+']').daterangepicker({
          opens: 'left',
          "locale": reachFormData.calendarLocale,
          "startDate": this.mediaInfoHistory.mediaStartDate,
          "endDate": this.mediaInfoHistory.mediaEndDate,
          "minDate" : this.rootStartDate,
          "maxDate": this.rootEndDate
        }, function(start, end, label) {
          // mediaInfo.mediaStartDate = start.format('YYYY-MM-DD');
          // mediaInfo.mediaEndDate = end.format('YYYY-MM-DD');
          mediaInfo.mediaStartDate = start.format('YY/MM/DD');
          mediaInfo.mediaEndDate = end.format('YY/MM/DD');
        });
      }
    }
  }
}
</script>

<style src="daterangepicker/daterangepicker.css"></style>
<style src="select2/dist/css/select2.min.css"></style><style src="select2-bootstrap-theme/dist/select2-bootstrap.min.css"></style>
<style>
.modal-header .close {
  display:none;
}
</style>
<style scoped>

#genderGroup .btn.active {
  color: #fff;
  border: 1px solid #428bca !important;
}

#ageGroup .btn.active {
  color: #fff;
  border: 1px solid #049372 !important;
}

.btn-age-group-lg {
  width: 234px;
  margin-right: 11px;
  font-weight: 600;
}

.btn-age-group-sm {
  width: 65px;
  margin-right: 5px;
  margin-bottom : 3px;
  font-weight: 600;
}
.inputPlaceholder::placeholder {
  color: #3e515b;
  font-weight: 600;
  text-align: center;
}
input[type="text"]:disabled {
    /* background: #dddddd; */
    border-radius: 25px;
    background: #ECF0F1;
}
.form-control:disabled, .form-control[readonly] {
    /* background: #dddddd; */
    border-radius: 25px;
    background: #ECF0F1;
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/views/reach/da/MediaTemplate.vue